import AboutNordroof from "./AboutNordroof";
import ContactsSection from "./ContactsSection";
import IntroSection from "./IntroSection";

export default function MainPage() {
   return (
      <div className="flex flex-col bg-custom-white-60">
         <IntroSection />
         <AboutNordroof />
         <ContactsSection />
      </div>
   );
}
